import { css } from '@emotion/react';

import { getMediaqueryStyled } from './mediaqueries';

const fontTypeBase = css`
  font-family: var(--font-family-graphik);
  font-style: normal;
`;

const fonts = {
  title: css`
    ${fontTypeBase}
    font-weight: 500;
    font-size: 80px;
    line-height: 95%;
    text-transform: uppercase;
    color: var(--colors-white-100);

    ${getMediaqueryStyled('xl')} {
      font-size: 60px;
    }

    ${getMediaqueryStyled('lg')} {
      font-size: 40px;
    }

    ${getMediaqueryStyled('sm')} {
      letter-spacing: -0.04em;
    }
  `,
  subtitle: css`
    ${fontTypeBase}
    font-weight: 400;
    font-size: 34px;
    line-height: 95%;
    text-transform: uppercase;
    color: var(--colors-white-100);

    ${getMediaqueryStyled('xl')} {
      font-size: 26px;
    }

    ${getMediaqueryStyled('lg')} {
      font-size: 18px;
    }
  `,
  main: css`
    ${fontTypeBase}
    font-weight: 400;
    font-size: 34px;
    line-height: 106%;
    color: var(--colors-white-100);

    ${getMediaqueryStyled('xl')} {
      font-size: 26px;
      line-height: 115%;
    }

    ${getMediaqueryStyled('lg')} {
      font-size: 18px;
      line-height: 111%;
    }

    ${getMediaqueryStyled('md')} {
      font-size: 24px;
      line-height: 108%;
    }
  `,
  side: css`
    ${fontTypeBase}
    font-weight: 400;
    font-size: 23px;
    line-height: 122%;
    color: var(--colors-silver-auxiliary);

    ${getMediaqueryStyled('xl')} {
      font-size: 18px;
    }

    ${getMediaqueryStyled('lg')} {
      font-size: 12px;
      line-height: 117%;
    }

    ${getMediaqueryStyled('md')} {
      font-size: 18px;
      line-height: 122%;
    }
  `,
  small: css`
    ${fontTypeBase}
    font-weight: 500;
    font-size: 12px;
    line-height: 117%;
    color: var(--colors-white-100);

    ${getMediaqueryStyled('xl')} {
      font-size: 16px;
      line-height: 112%;
    }

    ${getMediaqueryStyled('lg')} {
      font-size: 10px;
      line-height: 100%;
    }

    ${getMediaqueryStyled('md')} {
      font-size: 16px;
      line-height: 112%;
    }
  `,
  copyright: css`
    ${fontTypeBase}
    font-weight: 400;
    font-size: 15px;
    line-height: 114%;
    color: var(--colors-silver);
    text-decoration: none;

    ${getMediaqueryStyled('lg')} {
      font-size: 8px;
    }
  `,
};

export const getFont = (font: keyof typeof fonts) => {
  return fonts[font];
};
